import { sequence} from '@gongxigames/framework/slotV2/fsm/acts/ActFactory';
import {UIState} from '@gongxigames/framework/slotV2/baseClasses/uiState/UIState';
import {WaitRestoredUIAct} from '@gongxigames/framework/slotV2/ui/acts/WaitRestoredUIAct';
import {slotStore} from '@gongxigames/framework/slotV2/globals';

export class RestoreUIState extends UIState {
    public static readonly ID = 'RestoreUIState';

    public setAct(): void {
        this.act = sequence([
            WaitRestoredUIAct
        ]);
    }

    public canExecute(): boolean {
        return !slotStore.logic_nextActionIsSpin.value;
    }
}